import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import Preloader from "./Components/Preloader";
import NoMatch from "./Page/NoMatch";
import Whatelse from "./Page/Whatelse";
import WORKDATA from "./data/workData.json";
import HTMLTime from "./RedirectingPages/HTMLTime";
// import Header from "./Layout/Header";
// import About from "./Page/About";
// import Home from "./Page/Home";

const Header = React.lazy(() => import("./Layout/Header"));
const Home = React.lazy(() => import("./Page/Home"));
const About = React.lazy(() => import("./Page/About"));

function App() {
  console.log(
    `%cThe total number of real-world projects done are: ${
      WORKDATA.work.length +
      WORKDATA.democlones.length +
      WORKDATA.challenges.length +
      WORKDATA.portfolios.length +
      WORKDATA.Sprojects.length
    }`,
    "background: #F7F7F7; padding: 10px; color: #0b5750; font-size: xx-large;"
  );
  return (
    <>
      <Suspense fallback={<Preloader />}>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about/" element={<About />} />
          <Route path="/what-else/" element={<Whatelse />} />
          <Route path="/newsletter/html-time" element={<HTMLTime />} />
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
